import React from 'react'
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'
import HomePage from "../containers/pages/HomePage/HomePage";
import DetailPage from "../containers/pages/DetailPage/DetailPage";
import Navbar from "../containers/pages/shared/Navbar";



export default () => (
    <Router>
        <Navbar/>

        <Switch>
            <Route exact path='/' >
                <HomePage/>
            </Route>

            <Route exact  path={'/project/:id'} >
                    <DetailPage/>
            </Route>

            <Route path={'*'} >
                <h1> Not Found </h1>
            </Route>
        </Switch>
    </Router>

)